export default __webpack_public_path__ + "static/media/paint-roller.8ada7234.png";